import styled from "styled-components";

export const ReportContainer = styled.div`
  padding: 20px;
`;

export const PageTitle = styled.h2`
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

export const FiltersContainer = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
`;

export const FiltersTitle = styled.h4`
  margin-bottom: 15px;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: end;
  
  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1;
  
  /* Menor largura para inputs numéricos */
  &:has(input[type="number"]) {
    flex: 0.75;
    min-width: 150px;
  }
  
  @media (max-width: 1200px) {
    min-width: 100%;
    
    &:has(input[type="number"]) {
      min-width: 100%;
    }
  }
`;

export const FilterLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #495057;
  font-size: 14px;
`;

export const FilterSelect = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #495057;
  
  &:focus {
    outline: none;
    border-color: #404040;
    box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25);
  }
`;

export const FilterInput = styled.input`
  width: 100%;
  max-width: 150px;
  min-height: 18px;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  color: #495057;
  
  &:focus {
    outline: none;
    border-color: #404040;
    box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.25);
  }
  
  &::placeholder {
    color: #6c757d;
  }
`;

export const ButtonsGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 280px;
  justify-content: flex-end;
  
  @media (max-width: 1200px) {
    justify-content: center;
    min-width: 100%;
    margin-top: 10px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const DownloadButton = styled.button`
  padding: 8px 12px;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
    border-color: #000000;
    color: #000000;
  }
  
  &:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const HeatMapCard = styled.div`
  margin-top: 30px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeatMapTitle = styled.h3`
  margin: 0 0 8px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
`;

export const HeatMapSubtitle = styled.p`
  margin: 0 0 20px 0;
  color: #6c757d;
  font-size: 14px;
  font-weight: 400;
`;

export const HeatMapContent = styled.div`
  width: 100%;
  min-height: 500px;
`;